(function () {
  'use strict';

  // Device capability, not viewport width: phones stay direct in landscape.
  function prefersDirectLine() {
    var nav = typeof navigator === 'undefined' ? {} : navigator;
    if (nav.userAgentData && nav.userAgentData.mobile) return true;
    if (/Android|iPhone|iPad|iPod|Mobile/i.test(nav.userAgent || '')) return true;
    if (nav.platform === 'MacIntel' && Number(nav.maxTouchPoints) > 1) return true;
    return typeof window.matchMedia === 'function' &&
      window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  }

  function syncLineTrigger(node, url) {
    var trigger = node.querySelector && node.querySelector('[data-line-panel-toggle]');
    if (!trigger) return;
    var direct = prefersDirectLine();
    var wasDirect = node.dataset.lineDirect;
    node.dataset.lineDirect = direct ? 'true' : 'false';
    var panel = node.querySelector('[data-line-panel]');
    var alternative = node.querySelector('[data-line-panel-alternative]');
    if (url) trigger.setAttribute('href', url);
    if (alternative) {
      if (trigger.getAttribute('aria-disabled') === 'true') alternative.setAttribute('aria-disabled', 'true');
      else alternative.removeAttribute('aria-disabled');
    }
    if (direct) {
      trigger.setAttribute('data-chaoyang-line', '');
      ['linePlacement', 'lineKind', 'productId', 'productTitle', 'productSize'].forEach(function (key) {
        trigger.dataset[key] = node.dataset[key] || '';
      });
      trigger.removeAttribute('role');
      trigger.removeAttribute('aria-expanded');
      if (panel && wasDirect !== 'true') {
        panel.hidden = true;
        if (alternative) alternative.setAttribute('aria-expanded', 'false');
      }
    } else {
      trigger.removeAttribute('data-chaoyang-line');
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-expanded', panel && !panel.hidden ? 'true' : 'false');
    }
  }

  function positiveQuantity(value) {
    var text = String(value == null ? '' : value).trim();
    if (!/^\d+$/.test(text)) return '';
    var quantity = Number(text);
    return Number.isSafeInteger(quantity) && quantity >= 1 ? quantity : '';
  }

  function buildOaMessageUrl(basicId, message) {
    var id = String(basicId || '').trim();
    if (!/^@[A-Za-z0-9._-]+$/.test(id)) return '';
    return 'https://line.me/R/oaMessage/' + encodeURIComponent(id) + '/?' + encodeURIComponent(message || '');
  }

  function inferTireSize(productTitle) {
    var title = String(productTitle || '').trim();
    var match = title.match(/(?:^|\s)((?:\d{2,3}\/\d{2,3}R\d{2}(?:\.\d+)?(?:LT)?|\d{2}R\d{2}(?:\.\d+)?)(?:\s+\d{1,2}PR)?)(?=\s|$)/i);
    return match ? match[1].toUpperCase() : '';
  }

  function buildMessage(context) {
    var value = context || {};
    if (value.kind === 'wholesale') {
      return ['【法人価格・見積相談】', '会社名：', 'ご担当者名：', '商品・タイヤサイズ：', '希望本数：', '配送先の都道府県：', '希望時期：', 'ページURL：' + (value.pageUrl || '')].join('\n');
    }
    if (value.kind === 'search') {
      return ['【サイズ相談】', '検索したサイズ・型番：' + (value.searchTerm || ''), '商品URL：' + (value.pageUrl || '')].join('\n');
    }
    if (value.kind === 'faq') {
      return ['【交換場所・保証の相談】', '確認したい内容：', 'ページURL：' + (value.pageUrl || '')].join('\n');
    }
    if (value.kind === 'cart') {
      return ['【購入前の確認】', '確認したい内容：適合／在庫・納期／交換場所', 'カートURL：' + (value.pageUrl || '')].join('\n');
    }
    if (value.kind === 'general') {
      return ['【タイヤ相談】', '商品・サイズ：', '希望本数：', 'ページURL：' + (value.pageUrl || '')].join('\n');
    }
    var productSize = String(value.productSize || '').trim() || inferTireSize(value.productTitle);
    var quantity = positiveQuantity(value.quantity);
    if (value.kind === 'photo') {
      return [
        '【タイヤの適合・商品相談】',
        '商品：' + (value.productTitle || '未指定'),
        'サイズ：' + (productSize || '未指定'),
        '希望本数：' + (quantity ? quantity + '本' : '未入力'),
        '相談内容：',
        'URL：' + (value.pageUrl || '')
      ].join('\n');
    }
    if (value.kind === 'outlet') {
      return [
        '【アウトレット価格の相談】',
        'よりお得なアウトレットの対象・価格・在庫を確認したいです。',
        '検討中の商品：' + (value.productTitle || '未指定'),
        'サイズ：' + (productSize || '未指定'),
        '希望本数：' + (quantity ? quantity + '本' : '未入力'),
        '製造年・商品の状態・送料条件も教えてください。',
        'URL：' + (value.pageUrl || '')
      ].join('\n');
    }
    return [
      value.kind === 'sold_out' ? '【入荷・代替商品相談】' : (value.kind === 'quote' ? '【商品見積相談】' : '【商品相談】'),
      '商品：' + (value.productTitle || ''),
      'サイズ：' + productSize,
      '希望本数：' + (quantity ? quantity + '本' : '未入力'),
      'URL：' + (value.pageUrl || '')
    ].join('\n');
  }

  function contextFromNode(node) {
    var productTitle = node.dataset.productTitle || '';
    var productSize = node.dataset.productSize || inferTireSize(productTitle);
    if (!node.dataset.productSize && productSize) node.dataset.productSize = productSize;
    return {
      kind: node.dataset.lineKind || 'general',
      productTitle: productTitle,
      productSize: productSize,
      quantity: positiveQuantity(node.dataset.lineQuantity),
      pageUrl: node.dataset.productUrl || window.location.href,
      searchTerm: node.dataset.lineSearchTerm || ''
    };
  }

  function resetCopy(node) {
    var copy = node.querySelector && node.querySelector('[data-line-copy]');
    var status = node.querySelector && node.querySelector('[data-line-copy-status]');
    if (copy) {
      if (!copy.dataset.lineCopyLabel) copy.dataset.lineCopyLabel = copy.textContent;
      copy.dataset.lineCopyVersion = String((Number(copy.dataset.lineCopyVersion) || 0) + 1);
      copy.textContent = copy.dataset.lineCopyLabel;
      copy.disabled = false;
    }
    if (status) status.textContent = '';
  }

  function copyMessage(copy) {
    var owner = copy.closest && copy.closest('[data-line-context]');
    var panel = owner || copy.parentElement;
    var field = panel && panel.querySelector('[data-line-message-copy]');
    var status = panel && panel.querySelector('[data-line-copy-status]');
    if (!field) return;
    if (!copy.dataset.lineCopyLabel) copy.dataset.lineCopyLabel = copy.textContent;
    var version = String((Number(copy.dataset.lineCopyVersion) || 0) + 1);
    var text = field.value;
    copy.dataset.lineCopyVersion = version;
    copy.textContent = copy.dataset.lineCopyLabel;
    copy.disabled = false;
    if (status) status.textContent = '';
    function current() { return copy.dataset.lineCopyVersion === version && field.value === text; }
    function failed() {
      if (!current()) return;
      copy.disabled = false;
      copy.textContent = copy.dataset.lineCopyLabel;
      field.focus(); field.select();
      if (status) status.textContent = '自動コピーできませんでした。本文を選択しました。手動でコピーしてください。';
    }
    if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') { failed(); return; }
    copy.disabled = true;
    try {
      navigator.clipboard.writeText(text).then(function () {
        if (!current()) return;
        copy.disabled = false; copy.textContent = 'コピーしました';
        if (status) status.textContent = '相談文をコピーしました。LINEのトークに貼り付け、内容を確認して送信してください。';
      }).catch(failed);
    } catch (error) { failed(); }
  }

  function refreshContext(node) {
    var message = buildMessage(contextFromNode(node));
    var url = buildOaMessageUrl(node.dataset.lineBasicId, message);
    // Keep measured friend-add routes intact. Ordinary product advice still
    // opens its contextual oaMessage link; no arbitrary redirect is allowed.
    var friendAddUrl = String(node.dataset.lineFriendAddUrl || '');
    if (/^https:\/\/lin\.ee\/[A-Za-z0-9]+$/.test(friendAddUrl)) url = friendAddUrl;
    syncLineTrigger(node, url);
    var anchors = [];
    if (node.matches && node.matches('a[data-chaoyang-line]')) anchors.push(node);
    if (node.querySelectorAll) node.querySelectorAll('a[data-chaoyang-line]').forEach(function (anchor) { anchors.push(anchor); });
    else if (node.querySelector) {
      var anchor = node.querySelector('a[data-chaoyang-line]');
      if (anchor) anchors.push(anchor);
    }
    anchors.forEach(function (anchor) { if (url) anchor.setAttribute('href', url); });
    var copyField = node.querySelector && node.querySelector('[data-line-message-copy]');
    var qrOutput = node.querySelector && node.querySelector('[data-line-qr-output]');
    var panel = node.querySelector && node.querySelector('[data-line-panel]');
    if (copyField && copyField.value !== message) { resetCopy(node); copyField.value = message; }
    if (qrOutput && qrOutput.dataset.lineQrValue !== url) {
      qrOutput.dataset.lineQrValue = url;
      qrOutput.replaceChildren();
      qrOutput.removeAttribute('data-line-qr-rendered');
    }
    if (panel && !panel.hidden) renderQr(panel);
  }

  function refresh(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-line-context]')) refreshContext(scope);
    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-line-context]').forEach(refreshContext);
    }
  }

  function renderQr(panel) {
    var output = panel.querySelector('[data-line-qr-output]');
    var error = panel.querySelector('[data-line-qr-error]');
    if (!output || output.dataset.lineQrRendered === 'true') return;
    try {
      if (typeof window.qrcode !== 'function') throw new Error('QR library unavailable');
      if (!output.dataset.lineQrValue) throw new Error('QR value unavailable');
      var qr = window.qrcode(0, 'M');
      qr.addData(output.dataset.lineQrValue);
      qr.make();
      output.innerHTML = qr.createSvgTag({ scalable: true, margin: 4 });
      output.dataset.lineQrRendered = 'true';
      if (error) error.hidden = true;
    } catch (qrError) {
      output.replaceChildren();
      if (error) error.hidden = false;
    }
  }

  document.addEventListener('chaoyang:quantity-change', function (event) {
    var root = event.target;
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-line-context]').forEach(function (node) {
      node.dataset.lineQuantity = String(positiveQuantity(event.detail && event.detail.quantity));
    });
    refresh(root);
  });

  document.addEventListener('DOMContentLoaded', function () { refresh(document); });

  function togglePanel(control, forceOpen) {
    var owner = control.closest && control.closest('[data-line-context]') || control.parentElement;
    var panel = owner && owner.querySelector('[data-line-panel]');
    if (!panel) return;
    var wasHidden = panel.hidden;
    var opening = typeof forceOpen === 'boolean' ? forceOpen : panel.hidden;
    panel.hidden = !opening;
    var primary = owner.querySelector('[data-line-panel-toggle]');
    var alternative = owner.querySelector('[data-line-panel-alternative]');
    if (primary && !prefersDirectLine()) primary.setAttribute('aria-expanded', opening ? 'true' : 'false');
    if (alternative) alternative.setAttribute('aria-expanded', opening ? 'true' : 'false');
    if (opening) renderQr(panel);
    var output = panel.querySelector('[data-line-qr-output]');
    if (wasHidden && opening && !prefersDirectLine() && output && output.dataset.lineQrRendered === 'true') {
      try { owner.dispatchEvent(new CustomEvent('chaoyang:line-qr-open', { bubbles: true })); }
      catch (error) {}
    }
  }

  document.addEventListener('click', function (event) {
    var alternative = event.target.closest('[data-line-panel-alternative]');
    if (alternative) {
      event.preventDefault();
      if (alternative.getAttribute('aria-disabled') !== 'true') togglePanel(alternative);
      return;
    }
    var toggle = event.target.closest('[data-line-panel-toggle]');
    if (toggle) {
      if (toggle.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        return;
      }
      // Let the real anchor navigate under the original user gesture on mobile.
      if (prefersDirectLine()) return;
      event.preventDefault();
      togglePanel(toggle);
      return;
    }
    var copy = event.target.closest('[data-line-copy]');
    if (copy) copyMessage(copy);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      var owner = event.target.closest && event.target.closest('[data-line-context]');
      var panel = owner && owner.querySelector('[data-line-panel]');
      var control = owner && owner.querySelector(prefersDirectLine() ? '[data-line-panel-alternative]' : '[data-line-panel-toggle]');
      if (panel && !panel.hidden && control) { event.preventDefault(); togglePanel(control, false); control.focus(); }
      return;
    }
    if (event.key !== ' ') return;
    var toggle = event.target.closest && event.target.closest('[data-line-panel-toggle]');
    if (!toggle || prefersDirectLine()) return;
    event.preventDefault();
    if (toggle.getAttribute('aria-disabled') !== 'true') toggle.click();
  });

  window.ChaoyangLineConsult = {
    prefersDirectLine: prefersDirectLine,
    buildMessage: buildMessage,
    buildOaMessageUrl: buildOaMessageUrl,
    inferTireSize: inferTireSize,
    refresh: refresh
  };
})();
